import { Permission } from 'shared'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Role, useRolesTableContext } from '../../../../RolesTableContext'
import { useRestoreRoleMutation } from 'schema'

export function useRestoreOptions(): RestoreRowActionOptions<Role> {
  const { refetch } = useRolesTableContext()
  const [restoreRole] = useRestoreRoleMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreRole: {
        role: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreRole,
    onRestore: async ({ id }) => {
      await restoreRole({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
